import React, { useEffect, useRef } from 'react';

/** Renders trusted third-party Instagram embed HTML from site settings. */
export default function InstagramEmbed({ html }) {
  const ref = useRef(null);
  const trimmed = String(html || '').trim();

  useEffect(() => {
    if (!trimmed || !ref.current) return;
    const container = ref.current;
    const scripts = container.querySelectorAll('script');
    scripts.forEach((old) => {
      const next = document.createElement('script');
      Array.from(old.attributes).forEach((attr) => next.setAttribute(attr.name, attr.value));
      if (old.textContent) next.textContent = old.textContent;
      old.parentNode?.replaceChild(next, old);
    });
  }, [trimmed]);

  if (!trimmed) return null;

  return (
    <div
      ref={ref}
      className="instagram-embed-widget text-center"
      dangerouslySetInnerHTML={{ __html: trimmed }}
    />
  );
}
